
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#062521","fill-rule":"evenodd","d":"M27.2 10.5L16 17.375 4.8 10.5V7.75L16 14.625 27.2 7.75v2.75zm0-5.5H4.8C3.26 5 2.014 6.237 2.014 7.75L2 24.25C2 25.762 3.26 27 4.8 27h22.4c1.54 0 2.8-1.238 2.8-2.75V7.75C30 6.237 28.74 5 27.2 5z"}})])
      }
    
      }
    